import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        <section className="dark:bg-gray-800 dark:text-gray-100">
            <div className="container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row lg:justify-between">
                <div className="flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left">
                    <h1 className="text-5xl font-bold leading-none sm:text-6xl">Best way to learn <span className="text-indigo-400"> JavaScript</span>
                    </h1>
                    <p className="mt-6 mb-8 text-lg sm:mb-12">Learn in an interactive environment. Read short lessons, take notes, and complete challenges directly in your browser.
                    </p>
                    <div className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
                        <Link to="/courses/01" className="px-8 py-3 text-lg font-semibold rounded bg-indigo-400 text-white">Explore Courses</Link>
                        <Link to="/signin" className="px-8 py-3 text-lg font-semibold border rounded dark:border-gray-100 border-gray-900">Sign in</Link>
                    </div>
                </div>
                <div className="flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128">
                    <img src="https://www.mambaui.com/assets/svg/Business_SVG.svg" alt="" className="object-contain h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128" />
                </div>
            </div>
        </section>
    );
};

export default Hero;